import React from 'react';
import { CommonLabeledCheckInputProps } from '../../../types/common';
import OuterLabel from '../OuterLabel';
import Checkbox from '../Checkbox';
import ErrorLabel from '../ErrorLabel';

export const LabeledCheckboxTestId = 'labeledcheckbox-input';

export type LabeledCheckboxProps = CommonLabeledCheckInputProps & {
  onClick?: React.MouseEventHandler<HTMLInputElement>;
  renderChild?: boolean;
};

const LabeledCheckbox: React.FC<LabeledCheckboxProps> = ({
  name,
  label,
  errorLabel,
  className = '',
  inputClassName,
  labelClassName,
  defaultChecked,
  register,
  onBlur,
  onChange,
  onClick,
  onFocus,
  onKeyDown,
  renderChild = false,
}: LabeledCheckboxProps) => {
  return (
    <div className={`m-2 ${className}`} data-testid={LabeledCheckboxTestId}>
      <div>
        <Checkbox
          name={name}
          hasErrors={!!errorLabel}
          className={inputClassName}
          register={register}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          onFocus={onFocus}
          onClick={onClick}
          defaultChecked={defaultChecked}
          onChange={onChange}
        />
        <OuterLabel
          inputName={name}
          hasErrors={false}
          renderChild={renderChild}
          className={`ml-2 ${labelClassName}`}
        >
          {label}
        </OuterLabel>
      </div>
      <div>
        <ErrorLabel>{errorLabel}</ErrorLabel>
      </div>
    </div>
  );
};

export default LabeledCheckbox;
